import {
  Box,
  Center,
  Flex,
  HStack,
  Image,
  Spinner,
  Text,
  useToast,
  VStack,
} from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import BottomFixedButton from "components/BottomFixedButton";
import { BasketListStatus, ResStatus } from "lib/api/enum";
import { ItemModel } from "lib/api/model";
import useCheckList from "lib/hook/useCheckList";
import usePathNavigate from "lib/hook/usePathNavigate";
import withAuth from "lib/hook/withAuth";
import { useEffect, useState } from "react";
import { getItemList, setItemDrop } from "./api";
import ProductItem from "./components/ProductItem";

function ProductList() {
  const { data, isLoading } = useQuery(
    ["getItemList"],
    () =>
      getItemList({
        item_id: [],
        item_status: BasketListStatus.BLS_DEFAULT,
      }),
    {
      onError: (err: any) => {
        toast({
          title: "오류",
          description: err.message,
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top",
        });
      },
    }
  );

  const [listData, setListData] = useState<ItemModel[]>([]);
  useEffect(() => {
    console.log(data);
    if (
      !isLoading &&
      data !== null &&
      data?.status === ResStatus.RES_SUCCESS &&
      data?.command.item_list
    ) {
      setListData(data?.command.item_list);
    }
  }, [isLoading, data]);

  const { pathNavigate } = usePathNavigate();
  const toast = useToast();
  const [isEmptyList, setIsEmptyList] = useState(false);
  const checkList = useCheckList();

  const gotoDetail = (itemId: number) => {
    console.log(itemId);
    pathNavigate(`/products/${itemId}`);
  };
  const onOrderProducts = async () => {
    console.log("선택 제품 주문하기", checkList.checkedIdList);
    // 동준
    let items: string = "";
    checkList.checkedIdList.map(
      (v, index) => (items += `${index > 0 ? "," : ""}${v}`)
    );
    pathNavigate(`/order/ordersheet?items=${items}`);
  };

  const onCheckItem = (itemId: number, isChecked: boolean) => {
    checkList.checkItem(itemId, isChecked);
  };

  const onDeleteItem = async (itemId: number) => {
    try {
      const result = await setItemDrop({ item_id: [itemId] });
      if (result.status === ResStatus.RES_SUCCESS) {
        checkList.checkItem(itemId, false);
        const filtered = listData?.filter(
          (element) => element.item_id !== itemId
        );
        setListData([...filtered]);
        toast({
          title: "정보",
          description: "삭제되었습니다",
          status: "success",
          duration: 1000,
          position: "top",
        });
      } else {
        throw new Error(result?.status + "/" + result.result_message);
      }
    } catch (err: any) {
      toast({
        title: "오류",
        description: err.message,
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top",
      });
    }
  };

  return (
    <>
      {!isEmptyList ? (
        <Flex flexDirection={"column"}>
          <Center h="60px" fontSize="20px" fontWeight={"semibold"}>
            장바구니
          </Center>
          <Center w={"full"} h="66px" flexDirection="column" bg={"#f3f4f6"}>
            <HStack spacing={"3px"}>
              <Image
                src="/assets/images/icn_marks_exclamation.svg"
                boxSize={"13px"}
              />
              <Text fontSize={"13px"} fontWeight="bold" color={"#757575"}>
                저장 후 7일이 지난 제품은 삭제될 수 있어요.
              </Text>
            </HStack>
            <Text fontSize={"11px"}>
              - 7일이 지나기 전, 주문을 진행해 주세요.
            </Text>
          </Center>
          {isLoading ? (
            <Center mt={"20px"}>
              <Spinner size="xl" />
            </Center>
          ) : (
            listData.map((item, index) => (
              <ProductItem
                key={index}
                item={item}
                checkedIdList={checkList.checkedIdList}
                onCheckPressed={onCheckItem}
                onDeletePressed={onDeleteItem}
                gotoDetail={gotoDetail}
              />
            ))
          )}
          <Box h={"80px"} />
          <BottomFixedButton
            isDisabled={checkList.checkedIdList.length < 1}
            text="선택 제품 주문하기"
            colorScheme="black_button"
            onClick={onOrderProducts}
          />
        </Flex>
      ) : (
        <Flex flexDirection={"column"} h="full">
          <Center h="60px" fontSize="20px" fontWeight={"semibold"}>
            장바구니
          </Center>
          <VStack flex={1} bg={"#f5f5f5"} spacing={"38px"}>
            <Image
              src="/assets/images/img_orderBag_emptyState.svg"
              mt={"135px"}
            />
            <Text fontSize={"15px"}>내역이 없어요</Text>
          </VStack>
        </Flex>
      )}
    </>
  );
}
export default withAuth(ProductList);
